import { render, staticRenderFns } from "./V2CoursesFilters.vue?vue&type=template&id=515fb4ec&scoped=true&"
import script from "./V2CoursesFilters.vue?vue&type=script&lang=js&"
export * from "./V2CoursesFilters.vue?vue&type=script&lang=js&"
import style0 from "./V2CoursesFilters.vue?vue&type=style&index=0&id=515fb4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515fb4ec",
  null
  
)

export default component.exports